import React from "react";
import { NavLink } from "react-router-dom";
import direction from "../../../service/direction.json";
const CloudLandlinePhoneRegistration = () => {
  return (
    <div className="form-group row col-md-12 text-justify">
      <div className="col-md-6">
        <div style={{ width: "18rem;", fontSize: "20px" }}>
          <div className="card-body">
            <h5 className="card-title text-bold" style={{ fontSize: "30px" }}>
              ثبت نام تلفن ثابت ابری
            </h5>
            <p className="card-text">
              همانطور که مستحضر هستید سایت سایه بان شرکتی پیشرو در خدمات مبتنی
              بر پیامک میباشد که سرویس تلفن ابری بعنوان یک خدمت جدید در پنلهای
              سایه بان ارائه میشود.
              <br />
              یک تیر و دو نشان!
              <br />
              شما میتوانید یکی از پنلهای پیامک سایه بان را تهیه کنید که در تمام
              این پنل ها منوی تلفن ابری نیز وجود دارد تا برای ثبت و خرید خط تلفن
              ابری در پنل اقدام کنید.
            </p>
            <div className="text-center">
              <NavLink to="/FacilitiesAndTariffs" className="btn btn-info">
                انتخاب پنل پیامک
              </NavLink>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6 text-center">
        <img
          src={`${direction.ImgDesign}sip-trunk-register.jpg`}
          alt="سایه بان"
          style={{ width: "500px", height: "500px" }}
        />
      </div>
    </div>
  );
};

export default CloudLandlinePhoneRegistration;
